import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { getAcademicYears } from "../services/school/academicYear/getAcademicYears";

export const useGetAcademicYearQuery = (data: PagedRequestType) =>
  useQuery(
    ["academicYears-pagination", JSON.stringify(data)],
    () => getAcademicYears(data)
  );